<template>
  <div class="modal_compare_configs">
    <div class="header">
      <h4 class="title">
        {{ translate('config.save_config') }}
      </h4>
    </div>

    <div class="result_wrap">

      <div class="legend">
        <span class="add">
          {{ translate('config.legend.add') }}
        </span>
        <span class="del">
          {{ translate('config.legend.del') }}
        </span>
        <span class="mod">
          {{ translate('config.legend.mod') }}
        </span>
      </div>

      <div class="result">
        <CodeDiff
            :old-string="config_1"
            :new-string="config_2"
        />
      </div>

    </div>

    <div class="text-center">
      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="save"
      >
        {{ translate('config.save') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import CodeDiff from "vue-code-diff";

export default {
  name: "CompareConfigs",
  props: ["config_1", "config_2"],
  components: {
    CodeDiff
  },
  data () {
    return {
      old_config: {
        ver: null,
        config: ""
      },
      new_config: {
        ver: null,
        config: ""
      },
      result_compare: {},
    }
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save(){
      this.$emit("save")
    },
    selected_block(block){
      this.block = block
    },
  }
}

</script>

<style lang='scss'>
  .modal_compare_configs{
    padding: 10px;
    .header{
      text-align: center;
      .title{
        margin: 0 0 10px 0;
      }
    }
    .content{
      display: flex;
      .left, .right{
        width: 50%;
        .select_version{

        }
        .configuration{
          height: 200px;
          width: 100%;
          outline: none;
          resize: none;
          &::-webkit-scrollbar{
            width: 10px;
            cursor: pointer;
          }
        }
      }
      .left{
        padding: 0 5px 5px 0;
      }
      .right{
        padding: 0 0 5px 5px;
      }
    }
    .result{
      height: 400px;
      overflow: auto;
      &::-webkit-scrollbar{
        width: 10px;
      }
      &_wrap{
        .legend{
          display: flex;
          justify-content: space-around;
          margin-bottom: 10px;
          .add, .del, .mod{
            position: relative;
            font-size: 13px;
            line-height: 100%;
            &:before{
              position: absolute;
              left: -15px;
              width: 13px;
              height: 13px;
              content: "";
            }
          }
          .add {
            &:before{
              background-color: #dfd;
            }
          }
          .del{
            &:before{
              background-color: #ffb6ba;
            }
          }
          .mod{
            &:before{
              background-color: #fdf2d0;
            }
          }
        }
      }
    }
  }
</style>
